import { createContext, useContext, useState, useCallback } from 'react';

const translations = {
  fr: {
    // ── Navigation ──
    'nav.services': 'Nos Services',
    'nav.transport': 'Transport',
    'nav.didyouknow': 'Le Saviez-Vous ?',
    'nav.about': 'À Propos',
    'nav.contact': 'Contactez-nous',
    'nav.admin': 'Admin',
    'nav.account': 'Mon compte',
    'nav.logout': 'Déconnexion',
    'nav.clientarea': 'Espace Client',
    'nav.signin': 'Se connecter',
    'nav.signup': "S'inscrire",
    'nav.megamenu.sourcing.title': 'SOURCER DES FOURNISSEURS',
    'nav.megamenu.sourcing.text': "Grâce à plus de 10 ans de présence en Chine, nous identifions et sélectionnons des fournisseurs fiables adaptés à vos projets. Nous vérifions leur profil, évaluons leur capacité de production et contrôlons la conformité des produits afin de vous garantir un approvisionnement sécurisé et performant.",
    'nav.megamenu.appro.title': 'APPROVISIONNEMENT',
    'nav.megamenu.appro.text': "Avec notre expertise du marché chinois et notre réseau local, nous sécurisons et optimisons vos approvisionnements. Nous assurons le suivi des commandes, la coordination avec les fournisseurs et le contrôle de la conformité afin de garantir une supply chain fiable et performante.",
    'nav.transport.card.title': 'GESTION DU TRANSPORT',
    'nav.transport.card.text': "Global Sourcing Solution Group propose des solutions de gestion logistique de bout en bout grâce à son réseau de partenaires en France, en Belgique et en Chine. Nous assurons un transport de marchandises sûr, efficace et parfaitement coordonné, afin de garantir des livraisons fiables, ponctuelles et sans complexité.",

    // ── Footer ──
    'footer.desc': "Votre partenaire de confiance pour le sourcing, l'approvisionnement et la logistique internationale.",
    'footer.nav': 'Navigation',
    'footer.link.about': 'À propos de nous',
    'footer.link.services': 'Nos services',
    'footer.link.sourcing': 'Sourcing fournisseurs',
    'footer.link.appro': 'Approvisionnement',
    'footer.link.transport': 'Gestion du transport',
    'footer.info': 'Informations',
    'footer.follow': 'Suivez-nous',
    'footer.social_desc': 'Restez connecté et suivez notre actualité sur les réseaux sociaux.',
    'footer.rights': 'Tous droits réservés.',
    'footer.backtotop': '↑ Haut de page',

    // ── Home – Hero ──
    'home.hero.tag': 'VOTRE PARTENAIRE EN',
    'home.hero.em': 'SOURCING INTERNATIONAL',
    'home.hero.sub1': "Présents en Europe, en Asie et en Afrique, nous accompagnons les entreprises et les investisseurs",
    'home.hero.sub2': "à travers trois domaines d'expertise : le sourcing en Chine, le conseil en immobilier et informatique.",
    'home.hero.sub3': "Nous aidons les acheteurs du monde entier à sécuriser leurs approvisionnements en Chine,",
    'home.hero.sub4': "renforçant la fiabilité de leur supply chain et la performance de leurs achats.",
    'home.hero.cta': 'Nous contacter',

    // ── Home – Clients ──
    'home.clients.eye': 'Nos clients',
    'home.clients.h2a': 'ILS NOUS ',
    'home.clients.h2b': 'FONT CONFIANCE',

    // ── Home – Process ──
    'home.process.eye': 'Comment ça marche',
    'home.process.h2': 'NOTRE PROCESSUS',
    'home.process.sub': "De l'identification de vos besoins à la livraison, chaque étape est maîtrisée avec rigueur et professionnalisme.",
    'home.process.01.title': 'Identification des besoins',
    'home.process.01.desc': "Analyse approfondie de vos besoins pour proposer les solutions les plus adaptées à votre activité.",
    'home.process.02.title': 'Sourcing & Recherche',
    'home.process.02.desc': "Identification des meilleurs fournisseurs via notre réseau international étendu.",
    'home.process.03.title': 'Contrôle qualité',
    'home.process.03.desc': "Vérification rigoureuse de chaque produit avant validation et expédition.",
    'home.process.04.title': 'Logistique & Transport',
    'home.process.04.desc': "Gestion complète de la chaîne logistique, de l'expédition à la livraison.",
    'home.process.05.title': 'Suivi & Accompagnement',
    'home.process.05.desc': "Support continu post-livraison pour garantir votre entière satisfaction.",

    // ── Home – Chiffres ──
    'home.chiffres.title': 'GSSG en quelques chiffres',

    // ── Home – Expertise ──
    'home.expertise.eye': 'Ce que nous faisons',
    'home.expertise.h2': "NOS DOMAINES D'EXPERTISE",
    'home.expertise.1.title': 'Prestation de Services',
    'home.expertise.1.desc': "Nous accompagnons les entreprises dans leur transformation numérique, leur stratégie immobilière et leurs opérations de négociation.",
    'home.expertise.1.sub1': "Développement d'applications web & mobile sur mesure",
    'home.expertise.1.sub2': 'DataViz & solutions numériques',
    'home.expertise.1.sub3': 'Conseil en immobilier',
    'home.expertise.1.sub4': "Location de surfaces d'entrepôts de stockage",
    'home.expertise.1.sub5': 'Négociation pour le compte de tiers',
    'home.expertise.2.title': 'Distribution en Gros',
    'home.expertise.2.desc': "Nous proposons une large gamme de produits alimentaires et non alimentaires à destination des distributeurs et revendeurs.",
    'home.expertise.2.sub1': 'Boissons alcoolisées & non alcoolisées',
    'home.expertise.2.sub2': 'Céréales & produits alimentaires',
    'home.expertise.2.sub3': 'Produits de mer',
    'home.expertise.2.sub4': 'Fruits et légumes',
    'home.expertise.2.sub5': 'Packaging & conditionnement',
    'home.expertise.3.title': "Rachat d'Entreprises",
    'home.expertise.3.desc': "Nous intervenons en tant que partenaire stratégique pour identifier, évaluer et acquérir des entreprises à potentiel dans divers secteurs.",
    'home.expertise.3.sub1': 'Identification de cibles à potentiel',
    'home.expertise.3.sub2': 'Évaluation et due diligence',
    'home.expertise.3.sub3': "Accompagnement à l'acquisition",
    'home.expertise.3.sub4': "Tous secteurs d'activité",
    'home.expertise.4.title': 'Import / Export & Sourcing',
    'home.expertise.4.desc': "Nous identifions et sélectionnons des fournisseurs à prix compétitifs en Asie, et facilitons les échanges internationaux de produits non alimentaires vers l'Europe et l'Afrique.",
    'home.expertise.4.sub1': 'Recherche de fournisseurs à prix compétitifs',
    'home.expertise.4.sub2': 'Appareils & équipements industriels / électroniques',
    'home.expertise.4.sub3': 'Matériaux de construction',
    'home.expertise.4.sub4': 'Mobilier de bureau',
    'home.expertise.4.sub5': 'Gestion logistique & dédouanement',

    // ── Home – Why ──
    'home.why.eye': 'Nos atouts',
    'home.why.h2': 'POURQUOI NOUS CHOISIR',
    'home.why.1.title': 'Réseau International',
    'home.why.1.desc': "Des partenaires établis en Europe et en Afrique pour des solutions de distribution à l'échelle mondiale.",
    'home.why.2.title': 'Prix Compétitifs',
    'home.why.2.desc': "Des tarifs négociés et avantageux grâce à notre expertise en sourcing et à nos volumes d'achat.",
    'home.why.3.title': 'Service Sur Mesure',
    'home.why.3.desc': "Un accompagnement personnalisé, à l'écoute de chaque client pour des solutions vraiment adaptées.",
    'home.why.4.title': 'Réactivité 24h',
    'home.why.4.desc': "Réponse garantie sous 24 heures pour toutes vos demandes. Votre temps compte autant que le nôtre.",

    // ── Home – About ──
    'home.about.eye': 'A PROPOS',
    'home.about.h2': 'NOTRE SOCIÉTÉ',
    'home.about.p1': "est une entreprise française spécialisée dans la distribution en gros et le sourcing international. Nous accompagnons nos partenaires avec une large gamme de produits — agroalimentaire, fournitures industrielles, boissons et bien plus — à des prix compétitifs et avec un service de qualité.",
    'home.about.p2': "Animés par la satisfaction de nos partenaires, nous privilégions une relation fondée sur l'écoute, la proximité et la fiabilité. Grâce à notre expertise en sourcing et à notre réseau international, nous accompagnons aujourd'hui des clients en Europe, en Afrique et en Asie.",
    'home.about.cta': 'Travailler avec nous',

    // ── Home – Contact ──
    'home.contact.eye': 'Parlons de votre projet',
    'home.contact.h2': 'Contactez-nous',
    'home.contact.phone': 'Téléphone',
    'home.contact.form.name': 'Nom',
    'home.contact.form.name.ph': 'Votre nom',
    'home.contact.form.email': 'Email',
    'home.contact.form.email.ph': 'votre@email.com',
    'home.contact.form.subject': 'Sujet',
    'home.contact.form.subject.ph': 'Objet de votre demande',
    'home.contact.form.message': 'Message',
    'home.contact.form.message.ph': 'Décrivez votre besoin...',
    'home.contact.form.submit': 'Envoyer le message',
    'home.contact.thanks.title': 'Message envoyé !',
    'home.contact.thanks.desc': 'Merci pour votre message. Nous vous répondrons sous 24 heures.',
    'home.contact.thanks.new': 'Nouveau message',

    // ── Sourcing Fournisseurs ──
    'sf.hero.eye': 'Nos Services',
    'sf.hero.h1a': 'Sourcing Fournisseurs en Chine,',
    'sf.hero.h1b': 'trouvez des partenaires fiables',
    'sf.hero.sub': "Identification, qualification et analyse des fournisseurs pour sécuriser vos décisions d'approvisionnement.",
    'sf.hero.cta': 'Nous contacter',
    'sf.hero.process': 'Voir notre processus',
    'sf.avantages.eye': 'Pourquoi nous choisir',
    'sf.avantages.h2a': 'Une approche ',
    'sf.avantages.h2b': 'complète, fiable et transparente',
    'sf.avantages.lead': "Grâce à plus de 10 ans de présence en Chine, notre équipe terrain vous accompagne à chaque étape du sourcing avec rigueur et transparence.",
    'sf.av.1.title': 'Expérience & Expertise',
    'sf.av.1.desc': "Spécialiste des processus d'achat et de fabrication en Chine depuis plus de 10 ans.",
    'sf.av.2.title': 'Suivi Personnalisé',
    'sf.av.2.desc': "Un expert GSSG vous assiste et vous suit tout au long de vos projets d'approvisionnement.",
    'sf.av.3.title': 'Équipe Sur le Terrain',
    'sf.av.3.desc': "Une équipe opérationnelle basée en Chine pour une communication directe avec les usines.",
    'sf.av.4.title': 'Transparence & Intégrité',
    'sf.av.4.desc': "Aucune commission cachée, aucune dépendance fournisseur. Des solutions claires et honnêtes.",
    'sf.processus.eye': 'Notre méthodologie',
    'sf.processus.h2a': 'Un processus en ',
    'sf.processus.h2b': '5 étapes maîtrisées',
    'sf.processus.lead': "De l'analyse de vos besoins à la validation finale, chaque phase est encadrée par nos experts pour minimiser les risques et maximiser la qualité.",
    'sf.step.01.title': 'Analyse des besoins',
    'sf.step.01.desc': "Nous étudions en profondeur vos exigences produits, vos volumes, vos délais et vos contraintes budgétaires.",
    'sf.step.02.title': 'Prospection fournisseurs',
    'sf.step.02.desc': "Identification des usines via notre réseau local, collecte des documents et premières prises de contact.",
    'sf.step.03.title': 'Étude des offres',
    'sf.step.03.desc': "Analyse des devis, comparaison des capacités de production et sélection des meilleurs profils.",
    'sf.step.04.title': 'Évaluation & Vérification',
    'sf.step.04.desc': "Contrôle des certifications, vérification de la réputation et rapport détaillé sur chaque fournisseur.",
    'sf.step.05.title': 'Estimation logistique',
    'sf.step.05.desc': "Calcul des coûts de transport, droits de douane et taxes pour une vision complète du coût d'acquisition.",
    'sf.compare.eye': 'Analyse comparative',
    'sf.compare.h2a': 'Avec GSSG vs ',
    'sf.compare.h2b': 'sans GSSG',
    'sf.compare.th.aspect': 'Critère',
    'sf.compare.th.avec': '✓ Avec GSSG',
    'sf.compare.th.sans': 'Sans GSSG',
    'sf.cmp.1.aspect': 'Identification fournisseurs',
    'sf.cmp.1.avec': 'Fournisseurs identifiés et validés par notre équipe terrain',
    'sf.cmp.1.sans': 'Difficulté à trouver de vrais fabricants parmi les intermédiaires',
    'sf.cmp.2.aspect': 'Fiabilité des données',
    'sf.cmp.2.avec': 'Informations claires, vérifiées et exploitables',
    'sf.cmp.2.sans': 'Données incomplètes ou trompeuses fréquentes',
    'sf.cmp.3.aspect': 'Communication',
    'sf.cmp.3.avec': 'Communication transparente, sans barrière linguistique',
    'sf.cmp.3.sans': 'Barrière de la langue et écarts culturels importants',
    'sf.cmp.4.aspect': 'Commissions cachées',
    'sf.cmp.4.avec': 'Aucune commission cachée, tarification transparente',
    'sf.cmp.4.sans': 'Risques de fraude et de surfacturation',
    'sf.cmp.5.aspect': 'Gain de temps',
    'sf.cmp.5.avec': 'Processus maîtrisé, délais respectés',
    'sf.cmp.5.sans': 'Processus long et incertain sans garantie de résultat',
    'sf.services.eye': 'Ce que nous faisons',
    'sf.services.h2a': 'Nos ',
    'sf.services.h2b': 'prestations de sourcing',
    'sf.services.lead': "Un accompagnement sur mesure à chaque étape de votre chaîne d'approvisionnement.",
    'sf.svc.1.title': 'Étude de Sourcing',
    'sf.svc.1.desc': "Identification et sélection des fournisseurs les mieux adaptés à vos projets.",
    'sf.svc.2.title': 'Audit Fournisseurs',
    'sf.svc.2.desc': "Vérification complète du profil, des certifications et de la capacité de production.",
    'sf.svc.3.title': 'Prototypage',
    'sf.svc.3.desc': "Suivi de la fabrication des prototypes pour valider la conformité avant production.",
    'sf.svc.4.title': 'Passation de Commandes',
    'sf.svc.4.desc': "Négociation, validation et suivi des commandes auprès des fournisseurs sélectionnés.",
    'sf.svc.5.title': 'Contrôle Qualité',
    'sf.svc.5.desc': "Inspection des produits en cours et en fin de production pour garantir la conformité.",
    'sf.svc.6.title': 'Organisation Transport',
    'sf.svc.6.desc': "Coordination logistique complète, de l'usine jusqu'à votre entrepôt.",
    'sf.faq.eye': 'Questions fréquentes',
    'sf.faq.h2a': 'Tout ce que vous devez ',
    'sf.faq.h2b': 'savoir',
    'sf.faq.1.q': "Quelles sont les étapes pour trouver un fournisseur en Chine ?",
    'sf.faq.1.a': "Notre processus en 5 étapes couvre l'analyse de vos besoins, la prospection terrain, l'étude des offres reçues, la vérification des fournisseurs et l'estimation des coûts logistiques. Chaque étape est documentée et partagée avec vous en toute transparence.",
    'sf.faq.2.q': "Pourquoi faire appel à GSSG plutôt que de sourcer seul ?",
    'sf.faq.2.a': "Sourcer seul en Chine expose à des risques importants : barrière de la langue, fournisseurs non vérifiés, délais imprévus et coûts cachés. Notre équipe locale élimine ces risques grâce à son réseau établi et son expérience du terrain depuis plus de 10 ans.",
    'sf.faq.3.q': "Comment vérifiez-vous la fiabilité d'un fournisseur ?",
    'sf.faq.3.a': "Nous contrôlons les certifications (ISO, CE…), vérifions la réputation auprès de nos contacts locaux, visitons les usines si nécessaire et produisons un rapport détaillé incluant les capacités de production et l'historique de l'entreprise.",
    'sf.faq.4.q': "Quels types de produits pouvez-vous sourcer ?",
    'sf.faq.4.a': "Nous intervenons sur une large gamme de produits : textiles, électronique, équipements industriels, produits alimentaires, packaging, mobilier et bien d'autres. Contactez-nous pour évaluer la faisabilité de votre projet spécifique.",
    'sf.faq.5.q': "Quels sont vos délais pour trouver un fournisseur ?",
    'sf.faq.5.a': "Le délai dépend de la complexité du produit et du nombre de fournisseurs à évaluer. En général, une étude de sourcing complète prend entre 2 et 4 semaines. Nous vous fournissons un calendrier précis dès le début de la mission.",
    'sf.cta.h2a': 'Prêt à sécuriser votre ',
    'sf.cta.h2b': 'approvisionnement en Chine ?',
    'sf.cta.sub': "Contactez nos experts et obtenez une étude personnalisée sous 48h.",
    'sf.cta.btn': 'Demander une étude gratuite',
  },

  en: {
    // ── Navigation ──
    'nav.services': 'Our Services',
    'nav.transport': 'Transport',
    'nav.didyouknow': 'Did You Know?',
    'nav.about': 'About',
    'nav.contact': 'Contact Us',
    'nav.admin': 'Admin',
    'nav.account': 'My Account',
    'nav.logout': 'Sign Out',
    'nav.clientarea': 'Client Area',
    'nav.signin': 'Sign In',
    'nav.signup': 'Sign Up',
    'nav.megamenu.sourcing.title': 'SUPPLIER SOURCING',
    'nav.megamenu.sourcing.text': "With over 10 years of presence in China, we identify and select reliable suppliers suited to your projects. We verify their profile, assess their production capacity and control product compliance to guarantee secure and efficient procurement.",
    'nav.megamenu.appro.title': 'PROCUREMENT',
    'nav.megamenu.appro.text': "With our expertise of the Chinese market and our local network, we secure and optimize your procurement. We track orders, coordinate with suppliers and control compliance to guarantee a reliable and efficient supply chain.",
    'nav.transport.card.title': 'TRANSPORT MANAGEMENT',
    'nav.transport.card.text': "Global Sourcing Solution Group offers end-to-end logistics management solutions through its partner network in France, Belgium and China. We ensure safe, efficient and perfectly coordinated freight transport for reliable, on-time deliveries without complexity.",

    // ── Footer ──
    'footer.desc': "Your trusted partner for international sourcing, procurement and logistics.",
    'footer.nav': 'Navigation',
    'footer.link.about': 'About Us',
    'footer.link.services': 'Our Services',
    'footer.link.sourcing': 'Supplier Sourcing',
    'footer.link.appro': 'Procurement',
    'footer.link.transport': 'Transport Management',
    'footer.info': 'Information',
    'footer.follow': 'Follow Us',
    'footer.social_desc': 'Stay connected and follow our news on social media.',
    'footer.rights': 'All rights reserved.',
    'footer.backtotop': '↑ Back to top',

    // ── Home – Hero ──
    'home.hero.tag': 'YOUR PARTNER IN',
    'home.hero.em': 'INTERNATIONAL SOURCING',
    'home.hero.sub1': "Present in Europe, Asia and Africa, we support businesses and investors",
    'home.hero.sub2': "across three areas of expertise: sourcing in China, real estate and IT consulting.",
    'home.hero.sub3': "We help buyers worldwide secure their supply chains in China,",
    'home.hero.sub4': "strengthening their supply chain reliability and procurement performance.",
    'home.hero.cta': 'Contact Us',

    // ── Home – Clients ──
    'home.clients.eye': 'Our clients',
    'home.clients.h2a': 'THEY ',
    'home.clients.h2b': 'TRUST US',

    // ── Home – Process ──
    'home.process.eye': 'How it works',
    'home.process.h2': 'OUR PROCESS',
    'home.process.sub': "From identifying your needs to delivery, every step is managed with rigor and professionalism.",
    'home.process.01.title': 'Needs Assessment',
    'home.process.01.desc': "In-depth analysis of your needs to propose the most suitable solutions for your business.",
    'home.process.02.title': 'Sourcing & Research',
    'home.process.02.desc': "Identifying the best suppliers through our extensive international network.",
    'home.process.03.title': 'Quality Control',
    'home.process.03.desc': "Rigorous verification of each product before validation and shipment.",
    'home.process.04.title': 'Logistics & Transport',
    'home.process.04.desc': "Complete management of the logistics chain, from shipment to delivery.",
    'home.process.05.title': 'Monitoring & Support',
    'home.process.05.desc': "Continuous post-delivery support to ensure your complete satisfaction.",

    // ── Home – Chiffres ──
    'home.chiffres.title': 'GSSG by the numbers',

    // ── Home – Expertise ──
    'home.expertise.eye': 'What we do',
    'home.expertise.h2': 'OUR AREAS OF EXPERTISE',
    'home.expertise.1.title': 'Service Provision',
    'home.expertise.1.desc': "We support companies in their digital transformation, real estate strategy and negotiation operations.",
    'home.expertise.1.sub1': "Custom web & mobile application development",
    'home.expertise.1.sub2': 'DataViz & digital solutions',
    'home.expertise.1.sub3': 'Real estate consulting',
    'home.expertise.1.sub4': "Warehouse storage space rental",
    'home.expertise.1.sub5': 'Third-party negotiation',
    'home.expertise.2.title': 'Wholesale Distribution',
    'home.expertise.2.desc': "We offer a wide range of food and non-food products for distributors and resellers.",
    'home.expertise.2.sub1': 'Alcoholic & non-alcoholic beverages',
    'home.expertise.2.sub2': 'Cereals & food products',
    'home.expertise.2.sub3': 'Seafood products',
    'home.expertise.2.sub4': 'Fruits and vegetables',
    'home.expertise.2.sub5': 'Packaging & conditioning',
    'home.expertise.3.title': 'Business Acquisition',
    'home.expertise.3.desc': "We act as a strategic partner to identify, evaluate and acquire companies with potential in various sectors.",
    'home.expertise.3.sub1': 'Identification of high-potential targets',
    'home.expertise.3.sub2': 'Evaluation and due diligence',
    'home.expertise.3.sub3': "Acquisition support",
    'home.expertise.3.sub4': "All industry sectors",
    'home.expertise.4.title': 'Import / Export & Sourcing',
    'home.expertise.4.desc': "We identify and select competitively priced suppliers in Asia and facilitate international trade of non-food products to Europe and Africa.",
    'home.expertise.4.sub1': 'Sourcing competitively priced suppliers',
    'home.expertise.4.sub2': 'Industrial / electronic devices & equipment',
    'home.expertise.4.sub3': 'Construction materials',
    'home.expertise.4.sub4': 'Office furniture',
    'home.expertise.4.sub5': 'Logistics management & customs clearance',

    // ── Home – Why ──
    'home.why.eye': 'Our strengths',
    'home.why.h2': 'WHY CHOOSE US',
    'home.why.1.title': 'International Network',
    'home.why.1.desc': "Established partners in Europe and Africa for worldwide distribution solutions.",
    'home.why.2.title': 'Competitive Pricing',
    'home.why.2.desc': "Negotiated and advantageous rates thanks to our sourcing expertise and purchase volumes.",
    'home.why.3.title': 'Tailored Service',
    'home.why.3.desc': "Personalized support, listening to each client for truly adapted solutions.",
    'home.why.4.title': '24h Responsiveness',
    'home.why.4.desc': "Guaranteed response within 24 hours for all your requests. Your time matters as much as ours.",

    // ── Home – About ──
    'home.about.eye': 'ABOUT',
    'home.about.h2': 'OUR COMPANY',
    'home.about.p1': "is a French company specializing in wholesale distribution and international sourcing. We support our partners with a wide range of products — agri-food, industrial supplies, beverages and much more — at competitive prices and with quality service.",
    'home.about.p2': "Driven by our partners' satisfaction, we favor a relationship built on listening, proximity and reliability. Thanks to our sourcing expertise and international network, we now serve clients in Europe, Africa and Asia.",
    'home.about.cta': 'Work with us',

    // ── Home – Contact ──
    'home.contact.eye': "Let's talk about your project",
    'home.contact.h2': 'Contact Us',
    'home.contact.phone': 'Phone',
    'home.contact.form.name': 'Name',
    'home.contact.form.name.ph': 'Your name',
    'home.contact.form.email': 'Email',
    'home.contact.form.email.ph': 'your@email.com',
    'home.contact.form.subject': 'Subject',
    'home.contact.form.subject.ph': 'Subject of your request',
    'home.contact.form.message': 'Message',
    'home.contact.form.message.ph': 'Describe your need...',
    'home.contact.form.submit': 'Send message',
    'home.contact.thanks.title': 'Message sent!',
    'home.contact.thanks.desc': 'Thank you for your message. We will reply within 24 hours.',
    'home.contact.thanks.new': 'New message',

    // ── Sourcing Fournisseurs ──
    'sf.hero.eye': 'Our Services',
    'sf.hero.h1a': 'Supplier Sourcing in China,',
    'sf.hero.h1b': 'find reliable partners',
    'sf.hero.sub': "Identification, qualification and analysis of suppliers to secure your procurement decisions.",
    'sf.hero.cta': 'Contact Us',
    'sf.hero.process': 'See our process',
    'sf.avantages.eye': 'Why choose us',
    'sf.avantages.h2a': 'A ',
    'sf.avantages.h2b': 'complete, reliable and transparent approach',
    'sf.avantages.lead': "With over 10 years of presence in China, our field team accompanies you at every stage of sourcing with rigor and transparency.",
    'sf.av.1.title': 'Experience & Expertise',
    'sf.av.1.desc': "Specialist in purchasing and manufacturing processes in China for over 10 years.",
    'sf.av.2.title': 'Personalized Follow-up',
    'sf.av.2.desc': "A GSSG expert assists and accompanies you throughout your procurement projects.",
    'sf.av.3.title': 'On-site Team',
    'sf.av.3.desc': "An operational team based in China for direct communication with factories.",
    'sf.av.4.title': 'Transparency & Integrity',
    'sf.av.4.desc': "No hidden commissions, no supplier dependency. Clear and honest solutions.",
    'sf.processus.eye': 'Our methodology',
    'sf.processus.h2a': 'A process in ',
    'sf.processus.h2b': '5 mastered steps',
    'sf.processus.lead': "From analyzing your needs to final validation, each phase is supervised by our experts to minimize risks and maximize quality.",
    'sf.step.01.title': 'Needs Analysis',
    'sf.step.01.desc': "We study in depth your product requirements, volumes, deadlines and budget constraints.",
    'sf.step.02.title': 'Supplier Prospecting',
    'sf.step.02.desc': "Identification of factories through our local network, document collection and initial contacts.",
    'sf.step.03.title': 'Offer Study',
    'sf.step.03.desc': "Analysis of quotes, comparison of production capacities and selection of the best profiles.",
    'sf.step.04.title': 'Evaluation & Verification',
    'sf.step.04.desc': "Checking certifications, verifying reputation and detailed report on each supplier.",
    'sf.step.05.title': 'Logistics Estimate',
    'sf.step.05.desc': "Calculation of transport costs, customs duties and taxes for a complete view of acquisition cost.",
    'sf.compare.eye': 'Comparative analysis',
    'sf.compare.h2a': 'With GSSG vs ',
    'sf.compare.h2b': 'without GSSG',
    'sf.compare.th.aspect': 'Criteria',
    'sf.compare.th.avec': '✓ With GSSG',
    'sf.compare.th.sans': 'Without GSSG',
    'sf.cmp.1.aspect': 'Supplier identification',
    'sf.cmp.1.avec': 'Suppliers identified and validated by our field team',
    'sf.cmp.1.sans': 'Difficulty finding real manufacturers among intermediaries',
    'sf.cmp.2.aspect': 'Data reliability',
    'sf.cmp.2.avec': 'Clear, verified and usable information',
    'sf.cmp.2.sans': 'Frequent incomplete or misleading data',
    'sf.cmp.3.aspect': 'Communication',
    'sf.cmp.3.avec': 'Transparent communication, no language barrier',
    'sf.cmp.3.sans': 'Language barrier and significant cultural gaps',
    'sf.cmp.4.aspect': 'Hidden commissions',
    'sf.cmp.4.avec': 'No hidden commissions, transparent pricing',
    'sf.cmp.4.sans': 'Risks of fraud and overbilling',
    'sf.cmp.5.aspect': 'Time saving',
    'sf.cmp.5.avec': 'Controlled process, deadlines respected',
    'sf.cmp.5.sans': 'Long and uncertain process with no guarantee of results',
    'sf.services.eye': 'What we do',
    'sf.services.h2a': 'Our ',
    'sf.services.h2b': 'sourcing services',
    'sf.services.lead': "Tailored support at every stage of your supply chain.",
    'sf.svc.1.title': 'Sourcing Study',
    'sf.svc.1.desc': "Identification and selection of suppliers best suited to your projects.",
    'sf.svc.2.title': 'Supplier Audit',
    'sf.svc.2.desc': "Complete verification of profile, certifications and production capacity.",
    'sf.svc.3.title': 'Prototyping',
    'sf.svc.3.desc': "Follow-up on prototype manufacturing to validate compliance before production.",
    'sf.svc.4.title': 'Order Placement',
    'sf.svc.4.desc': "Negotiation, validation and monitoring of orders with selected suppliers.",
    'sf.svc.5.title': 'Quality Control',
    'sf.svc.5.desc': "Inspection of products during and at the end of production to ensure compliance.",
    'sf.svc.6.title': 'Transport Organization',
    'sf.svc.6.desc': "Complete logistics coordination, from factory to your warehouse.",
    'sf.faq.eye': 'Frequently asked questions',
    'sf.faq.h2a': 'Everything you need to ',
    'sf.faq.h2b': 'know',
    'sf.faq.1.q': "What are the steps to find a supplier in China?",
    'sf.faq.1.a': "Our 5-step process covers analyzing your needs, field prospecting, studying received offers, verifying suppliers and estimating logistics costs. Each step is documented and shared with you transparently.",
    'sf.faq.2.q': "Why use GSSG rather than sourcing alone?",
    'sf.faq.2.a': "Sourcing alone in China exposes you to significant risks: language barrier, unverified suppliers, unexpected delays and hidden costs. Our local team eliminates these risks through their established network and over 10 years of field experience.",
    'sf.faq.3.q': "How do you verify a supplier's reliability?",
    'sf.faq.3.a': "We check certifications (ISO, CE…), verify reputation through our local contacts, visit factories if necessary and produce a detailed report including production capacities and company history.",
    'sf.faq.4.q': "What types of products can you source?",
    'sf.faq.4.a': "We work on a wide range of products: textiles, electronics, industrial equipment, food products, packaging, furniture and many others. Contact us to assess the feasibility of your specific project.",
    'sf.faq.5.q': "What are your deadlines for finding a supplier?",
    'sf.faq.5.a': "The timeline depends on the product complexity and number of suppliers to evaluate. Generally, a complete sourcing study takes between 2 and 4 weeks. We provide a precise schedule from the start of the mission.",
    'sf.cta.h2a': 'Ready to secure your ',
    'sf.cta.h2b': 'supply chain in China?',
    'sf.cta.sub': "Contact our experts and get a personalized study within 48h.",
    'sf.cta.btn': 'Request a free study',
  },

  zh: {
    // ── Navigation ──
    'nav.services': '我们的服务',
    'nav.transport': '运输',
    'nav.didyouknow': '您知道吗？',
    'nav.about': '关于我们',
    'nav.contact': '联系我们',
    'nav.admin': '管理员',
    'nav.account': '我的账户',
    'nav.logout': '退出登录',
    'nav.clientarea': '客户专区',
    'nav.signin': '登录',
    'nav.signup': '注册',
    'nav.megamenu.sourcing.title': '供应商采购',
    'nav.megamenu.sourcing.text': "凭借10多年在中国的丰富经验，我们识别并筛选适合您项目的可靠供应商。我们核实供应商资质、评估生产能力并控制产品合规性，以确保安全高效的采购。",
    'nav.megamenu.appro.title': '供应管理',
    'nav.megamenu.appro.text': "凭借我们对中国市场的专业知识和本地网络，我们为您的采购提供保障和优化。我们跟踪订单、协调供应商并控制合规性，确保可靠高效的供应链。",
    'nav.transport.card.title': '运输管理',
    'nav.transport.card.text': "Global Sourcing Solution Group通过其在法国、比利时和中国的合作伙伴网络，提供端到端的物流管理解决方案。我们确保安全、高效、协调有序的货物运输，保证可靠准时且无复杂性的交付。",

    // ── Footer ──
    'footer.desc': "您在国际采购、供应和物流方面值得信赖的合作伙伴。",
    'footer.nav': '导航',
    'footer.link.about': '关于我们',
    'footer.link.services': '我们的服务',
    'footer.link.sourcing': '供应商采购',
    'footer.link.appro': '供应管理',
    'footer.link.transport': '运输管理',
    'footer.info': '信息',
    'footer.follow': '关注我们',
    'footer.social_desc': '关注我们，及时了解最新动态。',
    'footer.rights': '版权所有。',
    'footer.backtotop': '↑ 返回顶部',

    // ── Home – Hero ──
    'home.hero.tag': '您的',
    'home.hero.em': '国际采购合作伙伴',
    'home.hero.sub1': "我们立足欧洲、亚洲和非洲，为企业和投资者提供支持",
    'home.hero.sub2': "涵盖三大核心领域：中国采购、房地产咨询及信息技术服务。",
    'home.hero.sub3': "我们帮助全球买家在中国建立安全可靠的供应链，",
    'home.hero.sub4': "提升其供应链稳定性与采购效率。",
    'home.hero.cta': '联系我们',

    // ── Home – Clients ──
    'home.clients.eye': '我们的客户',
    'home.clients.h2a': '他们',
    'home.clients.h2b': '信任我们',

    // ── Home – Process ──
    'home.process.eye': '工作流程',
    'home.process.h2': '我们的流程',
    'home.process.sub': "从需求识别到交付，每个环节都以严谨和专业的态度管理。",
    'home.process.01.title': '需求分析',
    'home.process.01.desc': "深入分析您的需求，为您的业务提供最合适的解决方案。",
    'home.process.02.title': '采购与调研',
    'home.process.02.desc': "通过我们广泛的国际网络识别最优供应商。",
    'home.process.03.title': '质量控制',
    'home.process.03.desc': "在验收和发货前对每件产品进行严格检验。",
    'home.process.04.title': '物流与运输',
    'home.process.04.desc': "从装运到交付，全程管理物流链。",
    'home.process.05.title': '跟踪与支持',
    'home.process.05.desc': "持续的交付后支持，确保您的完全满意。",

    // ── Home – Chiffres ──
    'home.chiffres.title': 'GSSG 数字一览',

    // ── Home – Expertise ──
    'home.expertise.eye': '我们的业务',
    'home.expertise.h2': '我们的专业领域',
    'home.expertise.1.title': '服务供应',
    'home.expertise.1.desc': "我们支持企业进行数字化转型、房地产战略和谈判业务。",
    'home.expertise.1.sub1': "定制网络及移动应用开发",
    'home.expertise.1.sub2': '数据可视化及数字解决方案',
    'home.expertise.1.sub3': '房地产咨询',
    'home.expertise.1.sub4': "仓储空间租赁",
    'home.expertise.1.sub5': '代理谈判',
    'home.expertise.2.title': '批发分销',
    'home.expertise.2.desc': "我们为经销商和零售商提供各类食品和非食品产品。",
    'home.expertise.2.sub1': '酒精与非酒精饮料',
    'home.expertise.2.sub2': '谷物及食品',
    'home.expertise.2.sub3': '海产品',
    'home.expertise.2.sub4': '水果和蔬菜',
    'home.expertise.2.sub5': '包装与装箱',
    'home.expertise.3.title': '企业并购',
    'home.expertise.3.desc': "我们作为战略合作伙伴，识别、评估并收购各行业有潜力的企业。",
    'home.expertise.3.sub1': '高潜力目标识别',
    'home.expertise.3.sub2': '评估与尽职调查',
    'home.expertise.3.sub3': "收购支持",
    'home.expertise.3.sub4': "覆盖所有行业",
    'home.expertise.4.title': '进出口与采购',
    'home.expertise.4.desc': "我们在亚洲寻找并筛选具有竞争力价格的供应商，促进非食品产品向欧洲和非洲的国际贸易。",
    'home.expertise.4.sub1': '寻找具有竞争力的供应商',
    'home.expertise.4.sub2': '工业/电子设备',
    'home.expertise.4.sub3': '建筑材料',
    'home.expertise.4.sub4': '办公家具',
    'home.expertise.4.sub5': '物流管理与清关',

    // ── Home – Why ──
    'home.why.eye': '我们的优势',
    'home.why.h2': '为何选择我们',
    'home.why.1.title': '国际网络',
    'home.why.1.desc': "在欧洲和非洲拥有成熟合作伙伴，提供全球规模的分销解决方案。",
    'home.why.2.title': '竞争价格',
    'home.why.2.desc': "凭借我们的采购专业知识和采购量，获得谈判后的优惠价格。",
    'home.why.3.title': '定制服务',
    'home.why.3.desc': "个性化支持，倾听每位客户的需求，提供真正适配的解决方案。",
    'home.why.4.title': '24小时响应',
    'home.why.4.desc': "保证在24小时内回复您的所有请求。您的时间对我们同样重要。",

    // ── Home – About ──
    'home.about.eye': '关于我们',
    'home.about.h2': '我们的公司',
    'home.about.p1': "是一家专注于批发分销和国际采购的法国企业。我们以具有竞争力的价格和优质服务，为合作伙伴提供涵盖农食品、工业耗材、饮料等在内的广泛产品。",
    'home.about.p2': "以合作伙伴的满意为驱动力，我们注重建立基于倾听、亲近和可靠性的合作关系。凭借我们在采购领域的专业知识和国际网络，我们目前服务于欧洲、非洲和亚洲的客户。",
    'home.about.cta': '与我们合作',

    // ── Home – Contact ──
    'home.contact.eye': '谈谈您的项目',
    'home.contact.h2': '联系我们',
    'home.contact.phone': '电话',
    'home.contact.form.name': '姓名',
    'home.contact.form.name.ph': '您的姓名',
    'home.contact.form.email': '邮箱',
    'home.contact.form.email.ph': '您的邮箱',
    'home.contact.form.subject': '主题',
    'home.contact.form.subject.ph': '您的请求主题',
    'home.contact.form.message': '消息',
    'home.contact.form.message.ph': '描述您的需求...',
    'home.contact.form.submit': '发送消息',
    'home.contact.thanks.title': '消息已发送！',
    'home.contact.thanks.desc': '感谢您的消息。我们将在24小时内回复。',
    'home.contact.thanks.new': '新消息',

    // ── Sourcing Fournisseurs ──
    'sf.hero.eye': '我们的服务',
    'sf.hero.h1a': '中国供应商采购，',
    'sf.hero.h1b': '寻找可靠合作伙伴',
    'sf.hero.sub': "供应商的识别、资质审核与分析，保障您的采购决策安全。",
    'sf.hero.cta': '联系我们',
    'sf.hero.process': '查看我们的流程',
    'sf.avantages.eye': '为何选择我们',
    'sf.avantages.h2a': '一种',
    'sf.avantages.h2b': '全面、可靠且透明的方法',
    'sf.avantages.lead': "凭借10多年在中国的实地经验，我们的团队以严谨和透明的态度陪伴您完成采购的每个环节。",
    'sf.av.1.title': '经验与专业知识',
    'sf.av.1.desc': "专注中国采购和制造流程超过10年的专家。",
    'sf.av.2.title': '个性化跟进',
    'sf.av.2.desc': "GSSG专家全程协助并跟踪您的采购项目。",
    'sf.av.3.title': '现场团队',
    'sf.av.3.desc': "驻扎中国的运营团队，直接与工厂沟通。",
    'sf.av.4.title': '透明与诚信',
    'sf.av.4.desc': "无隐性佣金，无供应商依赖。清晰诚实的解决方案。",
    'sf.processus.eye': '我们的方法论',
    'sf.processus.h2a': '一个包含',
    'sf.processus.h2b': '5个专业步骤的流程',
    'sf.processus.lead': "从分析您的需求到最终验收，每个阶段均由我们的专家监督，以将风险降至最低并最大化质量。",
    'sf.step.01.title': '需求分析',
    'sf.step.01.desc': "我们深入研究您的产品要求、数量、交期和预算限制。",
    'sf.step.02.title': '供应商开发',
    'sf.step.02.desc': "通过我们的本地网络识别工厂，收集文件并进行初步联系。",
    'sf.step.03.title': '报价研究',
    'sf.step.03.desc': "分析报价，比较生产能力并筛选最佳候选者。",
    'sf.step.04.title': '评估与核实',
    'sf.step.04.desc': "检查认证、核实声誉并对每个供应商出具详细报告。",
    'sf.step.05.title': '物流估算',
    'sf.step.05.desc': "计算运输成本、关税和税费，全面了解采购总成本。",
    'sf.compare.eye': '对比分析',
    'sf.compare.h2a': '选择GSSG vs ',
    'sf.compare.h2b': '不选择GSSG',
    'sf.compare.th.aspect': '标准',
    'sf.compare.th.avec': '✓ 选择GSSG',
    'sf.compare.th.sans': '不选择GSSG',
    'sf.cmp.1.aspect': '供应商识别',
    'sf.cmp.1.avec': '由我们现场团队识别并验证的供应商',
    'sf.cmp.1.sans': '难以在中间商中找到真正的制造商',
    'sf.cmp.2.aspect': '数据可靠性',
    'sf.cmp.2.avec': '清晰、经过核实且可用的信息',
    'sf.cmp.2.sans': '经常出现不完整或误导性数据',
    'sf.cmp.3.aspect': '沟通',
    'sf.cmp.3.avec': '透明沟通，无语言障碍',
    'sf.cmp.3.sans': '语言障碍和重大文化差异',
    'sf.cmp.4.aspect': '隐性佣金',
    'sf.cmp.4.avec': '无隐性佣金，透明定价',
    'sf.cmp.4.sans': '欺诈和过度收费风险',
    'sf.cmp.5.aspect': '节省时间',
    'sf.cmp.5.avec': '流程可控，按时交付',
    'sf.cmp.5.sans': '漫长且不确定的流程，无结果保证',
    'sf.services.eye': '我们的业务',
    'sf.services.h2a': '我们的',
    'sf.services.h2b': '采购服务',
    'sf.services.lead': "在供应链的每个环节提供量身定制的支持。",
    'sf.svc.1.title': '采购研究',
    'sf.svc.1.desc': "识别并筛选最适合您项目的供应商。",
    'sf.svc.2.title': '供应商审计',
    'sf.svc.2.desc': "全面核实资质、认证和生产能力。",
    'sf.svc.3.title': '原型制作',
    'sf.svc.3.desc': "跟进原型制造，在生产前验证合规性。",
    'sf.svc.4.title': '订单下达',
    'sf.svc.4.desc': "与选定供应商协商、确认和跟踪订单。",
    'sf.svc.5.title': '质量控制',
    'sf.svc.5.desc': "在生产过程中和生产结束时检验产品，确保合规性。",
    'sf.svc.6.title': '运输安排',
    'sf.svc.6.desc': "从工厂到您的仓库，提供完整的物流协调服务。",
    'sf.faq.eye': '常见问题',
    'sf.faq.h2a': '您需要了解的',
    'sf.faq.h2b': '一切',
    'sf.faq.1.q': "在中国找到供应商需要哪些步骤？",
    'sf.faq.1.a': "我们的5步流程涵盖：分析您的需求、实地开发、研究收到的报价、核实供应商以及估算物流成本。每个步骤均有文档记录，并与您完全透明地共享。",
    'sf.faq.2.q': "为什么选择GSSG而不是自行采购？",
    'sf.faq.2.a': "在中国独立采购面临重大风险：语言障碍、未经核实的供应商、意外延误和隐性成本。我们的本地团队凭借10多年的实地经验和成熟网络消除了这些风险。",
    'sf.faq.3.q': "您如何核实供应商的可靠性？",
    'sf.faq.3.a': "我们检查认证（ISO、CE等），通过当地联系人核实声誉，必要时参观工厂，并出具详细报告，包括生产能力和公司历史。",
    'sf.faq.4.q': "您可以采购哪类产品？",
    'sf.faq.4.a': "我们涉及各类产品：纺织品、电子产品、工业设备、食品、包装、家具等。请联系我们评估您具体项目的可行性。",
    'sf.faq.5.q': "找到供应商需要多长时间？",
    'sf.faq.5.a': "时间取决于产品的复杂性和需要评估的供应商数量。通常，完整的采购研究需要2至4周。我们在任务开始时即提供精确的时间表。",
    'sf.cta.h2a': '准备好保障您的',
    'sf.cta.h2b': '中国供应链安全了吗？',
    'sf.cta.sub': "联系我们的专家，在48小时内获得个性化研究报告。",
    'sf.cta.btn': '申请免费研究',
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem('gssg_lang') || 'fr');

  const t = useCallback((key) => translations[lang]?.[key] ?? translations.fr[key] ?? key, [lang]);

  const setLanguage = useCallback((l) => {
    setLang(l);
    localStorage.setItem('gssg_lang', l);
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
